import type { ReactNode } from 'react';
import RomyIcon from '../RomyIcon';

interface AssistantMessageProps {
  children: ReactNode;
  className?: string;
  'data-message-id'?: string;
  'data-message-role'?: string;
}

export default function AssistantMessage({ children, className, ...dataAttrs }: AssistantMessageProps) {
  return (
    <div className={`flex justify-start group ${className ?? ''}`} {...dataAttrs}>
      {/* Desktop: icon on the left, aligned to top of first text line */}
      <div className="hidden md:block flex-shrink-0 mt-0.5 mr-3 text-pink-500">
        <RomyIcon size={22} />
      </div>
      <div className="flex-1 min-w-0 max-w-[85%] md:max-w-[75%] text-gray-800 dark:text-gray-100">
        {/* Mobile: icon above content */}
        <div className="md:hidden mb-1.5 text-pink-500">
          <RomyIcon size={22} />
        </div>
        {children}
      </div>
    </div>
  );
}
